import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";
const API = `${BASE_URL}/api/admin`;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
    "Content-Type": "application/json",
  },
});

const investorService = {
  /* ---------------- LINKED NEW BACKEND SUMMARY ---------------- */

  getLinkedInvestorSummary() {
    return axios.get(`${API}/investors/linked-summary`, authHeader()).then((res) => res.data);
  },

  getAllInvestments() {
    return axios.get(`${API}/investor-investments`, authHeader()).then((res) => res.data);
  },

  /* ---------------- INVESTORS ---------------- */

  getAllInvestors() {
    return axios
      .get(`${API}/investors/linked-summary`, authHeader())
      .then((res) => (Array.isArray(res.data) ? res.data : res.data?.investors || []))
      .catch(() => axios.get(`${API}/investors`, authHeader()).then((res) => res.data));
  },

  getInvestorById(investorId) {
    return axios.get(`${API}/investors/${investorId}`, authHeader()).then((res) => res.data);
  },

  createInvestor(data) {
    return axios.post(`${API}/investors`, data, authHeader()).then((res) => res.data);
  },

  updateInvestor(investorId, data) {
    return axios.put(`${API}/investors/${investorId}`, data, authHeader()).then((res) => res.data);
  },

  deleteInvestor(investorId) {
    return axios.delete(`${API}/investors/${investorId}`, authHeader()).then((res) => res.data);
  },

  /* ---------------- INVESTMENTS ---------------- */

  addInvestment(data) {
    return axios.post(`${API}/investor-investments`, data, authHeader()).then((res) => res.data);
  },

  getInvestmentsByInvestor(investorId) {
    return axios.get(`${API}/investor-investments/investor/${investorId}`, authHeader()).then((res) => res.data);
  },
};

export default investorService;
